import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";
import { logEvent } from "@src/appV2/lib/analytics";
import { CHILDCARE_REFERRAL_POST_BOOKING_IAM_EVENTS } from "@src/appV2/lib/analytics/events";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { type ModalShiftData } from "@src/appV2/redesign/Shift/types";
import { type UseModalState } from "@src/appV2/redesign/system/ui-components";
import { WORKER_REFERRALS_SHARE_LINK_PATH_FULL } from "@src/appV2/Referral/path";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { ChildcareReferralPromptBottomSheet } from "./ChildcareReferralPromptBottomSheet";
import { DEFAULT_CHILDCARE_REFERRAL_POST_BOOKING_IAM_CONFIG } from "./constants";

interface ChildcareReferralPromptBottomSheetContainerProps {
  modalState: UseModalState;
  shift: ModalShiftData;
}

export function ChildcareReferralPromptBottomSheetContainer(
  props: ChildcareReferralPromptBottomSheetContainerProps
) {
  const { modalState, shift } = props;
  const history = useHistory();

  const { copy } = useCbhFlag(CbhFeatureFlag.CHILDCARE_REFERRAL_POST_BOOKING_IAM, {
    defaultValue: DEFAULT_CHILDCARE_REFERRAL_POST_BOOKING_IAM_CONFIG,
  });

  const eventPayload = {
    shiftId: shift.id,
    workplaceId: shift.workplace.id,
    workplaceType: shift.workplace.attributes.type,
    msa: shift.workplace.attributes.location.msa,
  };

  useLogEffect(
    CHILDCARE_REFERRAL_POST_BOOKING_IAM_EVENTS.CHILDCARE_REFERRAL_POST_BOOKING_IAM_VIEWED,
    eventPayload
  );

  const handleDismiss = useCallback(() => {
    logEvent(
      CHILDCARE_REFERRAL_POST_BOOKING_IAM_EVENTS.CHILDCARE_REFERRAL_POST_BOOKING_IAM_DISMISSED,
      eventPayload
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCtaClick = useCallback(() => {
    logEvent(
      CHILDCARE_REFERRAL_POST_BOOKING_IAM_EVENTS.CHILDCARE_REFERRAL_POST_BOOKING_IAM_CTA_CLICKED,
      eventPayload
    );
    modalState.closeModal();
    history.push(WORKER_REFERRALS_SHARE_LINK_PATH_FULL);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history, modalState]);

  return (
    <ChildcareReferralPromptBottomSheet
      modalState={modalState}
      copy={copy}
      onDismiss={handleDismiss}
      onCtaClick={handleCtaClick}
    />
  );
}
